import React from 'react';
import { Button } from 'reactstrap';
import styled from 'styled-components';

import { getStyledThemeColor } from '@portals/utils';

import { useBrandingContext } from './branding.context';

export function Footer() {
  const { isPristine, revertChanges, isLoading, saveChanges } =
    useBrandingContext();

  return (
    <Container>
      <Button
        color="light"
        onClick={revertChanges}
        disabled={isPristine || isLoading}
      >
        Cancel
      </Button>

      <Button
        color="primary"
        onClick={saveChanges}
        disabled={isPristine || isLoading}
      >
        Save Changes
      </Button>
    </Container>
  );
}

const Container = styled.div`
  border-top: 1px solid ${getStyledThemeColor('gray200')};
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding: 0 25px;
  height: 56px;
  background-color: ${getStyledThemeColor('white')};

  button {
    &:first-of-type {
      margin-right: 15px;
    }
  }
`;
